import type { DurationRange, MarketplaceDeliverableType, MarketplaceOrderDeliverable } from '@foodfluence/shared';
import { deliverableRequiresPublishedPost } from '@foodfluence/shared';

function durationSnippet(d?: DurationRange | null): string | null {
  if (!d) return null;
  if ((d as { displayText?: string }).displayText?.trim()) return (d as { displayText?: string }).displayText!.trim();
  if (d.unit === 'seconds' && d.min != null && d.max != null) return `${d.min}–${d.max}s`;
  if (d.unit === 'seconds' && d.min != null) return `${d.min}s+`;
  return null;
}

export function marketplaceOrderIsRawUgcRequirement(r: MarketplaceOrderDeliverable): boolean {
  const hay = `${r.additionalInformation ?? ''} ${r.guidelines?.additionalInfo ?? ''}`.toLowerCase();
  return hay.includes('raw');
}

export function marketplaceOrderRequirementUploadSubtitle(r: MarketplaceOrderDeliverable): string {
  const durPart = durationSnippet(r.duration ?? null);
  const raw = marketplaceOrderIsRawUgcRequirement(r);
  const t: MarketplaceDeliverableType = r.type;

  if (raw) return 'Raw clips for brand reuse · 9:16 · unedited';
  if (!deliverableRequiresPublishedPost(t)) {
    return durPart ? `Brand specs · ${durPart}` : 'Brand specs · upload files';
  }
  if (t === 'tiktok' || t === 'instagram_reel') return `Vertical video · 9:16 · ${durPart ?? '15–60s'}`;
  if (t === 'instagram_story') return `Vertical · 9:16 · ${durPart ?? 'up to 15s each'}`;
  if (t === 'instagram_post' || t === 'instagram_carousel') return `Square / feed · ${durPart ?? 'brand specs'}`;
  if (t === 'tiktok_photo_carousel') return `TikTok photo carousel · ${durPart ?? 'brand specs'}`;
  return `Vertical video · 9:16 · ${durPart ?? 'brand specs'}`;
}
